import { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import CommonService from "../../services/common.service";
import { useStateContext } from "../../contexts/ContextProvider";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardGreeting from "../DashboardGreeting";
import { Card, Skeleton } from "antd";
import { useLocation } from "react-router-dom";
import LeaveHistoryService from "../../services/leaveHistory.service";

const AddNewEmployee = ({ user }) => {
  const navHeading = "Add New Employee";

  const location = useLocation();

  const { redirectBack } = location.state || {};

  const { employess } = useStateContext();

  const [validated, setValidated] = useState(false);

  const [loading, setLoading] = useState(false);

  const [locations, setLocations] = useState([]);

  const [rmList, setRmList] = useState([]);
  const [hrList, setHRList] = useState([]);

  const marriedStatusOptions = [
    { label: "Married", value: "Married" },
    { label: "Unmarried", value: "Unmarried" },
  ];

  const roles = [
    {
      label: "HR",
      value: "1",
    },
    {
      label: "Reporting Manager",
      value: "2",
    },
    {
      label: "Employee",
      value: "3",
    },
    {
      label: "Admin",
      value: "4",
    },
  ];

  const [departmentList, setDepartmentList] = useState([]);

  const initialData = {
    name: "",
    email: "",
    mobileno: "",
    gender: "",
    role: "",
    designation: "",
    department: "",
    departmentid: 0,
    joiningdate: "",
    comfirmation_date: "",
    apriaisal_Month: "",
    maritial_Status: "",
    payroll: "",
    dob: "",
    empcode: "",
    empid: "",
    location: "",
    status: "",
    managerid: "",
    hR_id: "AEON032",
    empProfilePicName: "",
    deviceCode: "",
    isprobation: "1",
    platform: "",
  };

  const [details, setDetails] = useState(initialData);

  const platformOptions = [
    { label: "eSSL", value: "1" },
    { label: "Attendrix", value: "2" },
  ];

  const fetchRmList = () => {
    CommonService.GetRmList()
      .then((resp) => {
        if (resp.data) {
          const rmlists = resp.data.map((item) => ({
            label: item.name,
            value: item.empid,
          }));
          setRmList(rmlists);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchRmList();
  }, []);

  // console.log("employess", employess);

  useEffect(() => {
    const payload = {
      empId: "",
    };
    LeaveHistoryService.getEmpInfo(payload)
      .then((resp) => {
        const hrLists = resp.data
          .filter((item) => item.department === "HR")
          .map((item2) => ({
            label: item2.name,
            value: item2.empId,
          }));
        setHRList(hrLists);
      })
      .catch((e) => console.log(e));
  }, []);

  const fetchDepartmentList = useCallback(() => {
    CommonService.getAlldepts()
      .then((resp) => {
        if (resp.data) {
          setDepartmentList(resp.data);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  const fetchLocations = useCallback(() => {
    CommonService.getAllLocations()
      .then((resp) => {
        const locationsData = resp.data.map((item) => ({
          label: item.location,
          value: item.location,
        }));
        setLocations(locationsData);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchLocations();
    fetchDepartmentList();
  }, [fetchLocations, fetchDepartmentList]);

  const handleInputChnage = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleGenderChange = (e) => {
    const { value } = e.target;
    setDetails((prevData) => ({
      ...prevData,
      gender: value,
    }));
  };

  const handleChangeStatus = (e) => {
    const { name, checked } = e.target;
    setDetails((prevData) => ({
      ...prevData,
      [name]: checked ? "1" : "0",
    }));
  };

  const handleAddEmployee = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setLoading(true);

    CommonService.insertUser(details)
      .then((resp) => {
        // console.log(resp);
        if (resp.data) {
          setDetails(initialData);
          setLoading(false);
          toast.success(resp.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        toast.warn(e.response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <div className="dashboard-container hr">
        <DashboardGreeting
          navHeading={navHeading}
          redirectBack={redirectBack}
          user={user}
        />
      </div>

      <div className="">
        <div className="sort-list">
          <ToastContainer />
          {loading ? (
            <>
              <Skeleton active={loading} />
            </>
          ) : (
            <>
              <Form
                noValidate
                validated={validated}
                onSubmit={handleAddEmployee}
              >
                <Card className="mb-3" title="Personal Information">
                  <div className="row">
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={details.name}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={details.email}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile No. </Form.Label>
                        <Form.Control
                          type="text"
                          name="mobileno"
                          value={details.mobileno}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Gender *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="gender"
                          value={details.gender}
                          onChange={handleGenderChange}
                          required
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Maritial Status </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="maritial_Status"
                          value={details.maritial_Status}
                          onChange={handleInputChnage}
                        >
                          <option value="">Select</option>
                          {Array.isArray(marriedStatusOptions)
                            ? marriedStatusOptions.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>DOB *</Form.Label>
                        <Form.Control
                          type="date"
                          name="dob"
                          value={details.dob}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Card>

                <Card className="mb-3" title="Other Information">
                  <div className="row">
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Designation *</Form.Label>
                        <Form.Control
                          type="text"
                          name="designation"
                          value={details.designation}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Department *</Form.Label>
                        <Form.Select
                          name="departmentid"
                          value={details.departmentid}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select Department</option>
                          {Array.isArray(departmentList)
                            ? departmentList.map((item) => {
                                return (
                                  <option value={item.deptId}>
                                    {item.deptName}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Location *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="location"
                          value={details.location}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select Location</option>
                          {Array.isArray(locations)
                            ? locations.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Role *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="role"
                          value={details.role}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select Role</option>
                          {Array.isArray(roles)
                            ? roles.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>RM *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="managerid"
                          value={details.managerid}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select RM</option>
                          {Array.isArray(rmList)
                            ? rmList.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>HR *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="hR_id"
                          value={details.hR_id}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select HR</option>
                          {Array.isArray(hrList)
                            ? hrList.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Joining Date *</Form.Label>
                        <Form.Control
                          type="date"
                          name="joiningdate"
                          value={details.joiningdate}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Confirmation Date *</Form.Label>
                        <Form.Control
                          type="date"
                          name="comfirmation_date"
                          value={details.comfirmation_date}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Appraisal Month </Form.Label>
                        <Form.Control
                          type="month"
                          name="apriaisal_Month"
                          value={details.apriaisal_Month}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Payroll *</Form.Label>
                        <Form.Control
                          type="text"
                          name="payroll"
                          value={details.payroll}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Emp Id * </Form.Label>
                        <Form.Control
                          type="text"
                          name="empid"
                          value={details.empid}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>ESSL Code *</Form.Label>
                        <Form.Control
                          type="text"
                          name="empcode"
                          value={details.empcode}
                          onChange={handleInputChnage}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Leave Allocate Year</Form.Label>
                        <Form.Control
                          type="text"
                          name="leaveAllocateYear"
                          value={details.leaveAllocateYear}
                          onChange={handleInputChnage}
                          
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Allocated Leave</Form.Label>
                        <Form.Control
                          type="text"
                          name="allocatedLeave"
                          value={details.allocatedLeave}
                          onChange={handleInputChnage}
                          
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Yearly Balance</Form.Label>
                        <Form.Control
                          type="text"
                          name="yearlyBalLeave"
                          value={details.yearlyBalLeave}
                          onChange={handleInputChnage}
                          
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Platform *</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="platform"
                          value={details.platform}
                          onChange={handleInputChnage}
                          required
                        >
                          <option value="">Select</option>
                          {Array.isArray(platformOptions)
                            ? platformOptions.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>IsProbation</Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch1"
                          name="isprobation"
                          label={details.isprobation === "1" ? "Yes" : "No"}
                          checked={
                            details.isprobation === "1" ? true : false
                          }
                          onChange={handleChangeStatus}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Card>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex gap-2">
                      <button className="btn btn-primary" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AddNewEmployee;
